import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({ selector: 'table[appResponsiveTable], table.data-table', standalone: true })
export class ResponsiveTableDirective implements AfterViewInit, OnDestroy {
  private observer?: MutationObserver;

  constructor(private readonly element: ElementRef<HTMLTableElement>) {}

  ngAfterViewInit(): void {
    const table = this.element.nativeElement;
    table.classList.add('ts-responsive-table');
    this.labelCells();
    this.observer = new MutationObserver(() => this.labelCells());
    this.observer.observe(table.tBodies[0] ?? table, { childList: true, subtree: true });
  }

  ngOnDestroy(): void { this.observer?.disconnect(); }

  private labelCells(): void {
    const table = this.element.nativeElement;
    const labels = Array.from(table.querySelectorAll<HTMLTableCellElement>('thead th'))
      .map(header => (header.textContent ?? '').replace(/\s+/g, ' ').trim());
    Array.from(table.tBodies).forEach(body => Array.from(body.rows).forEach(row =>
      Array.from(row.cells).forEach((cell, index) => {
        if (cell.colSpan > 1) cell.dataset['fullRow'] = 'true';
        else cell.dataset['label'] = labels[index] || 'Detalle';
      })
    ));
  }
}
